import { fileUrl } from '../lib/api';
import { SITE_STATUS, POSITIONS } from '../lib/status';
import { TriangleAlert } from 'lucide-react';

export default function StatusTile({ site, onClick }) {
  const cfg = SITE_STATUS[site.current_status] || SITE_STATUS.not_installed;
  const warned = ['damaged', 'repair_pending'].includes(site.current_status);
  return (
    <button
      data-testid={`site-tile-${site.position_type}-${site.id}`}
      onClick={onClick}
      className={`tile-press relative flex min-h-[112px] w-full flex-col justify-between overflow-hidden rounded-xl border-2 ${cfg.ring} bg-gradient-to-br ${cfg.tint} to-card p-3 text-left`}
    >
      {warned && (
        <span data-testid={`site-warning-${site.id}`} className="absolute left-2 top-2 z-10 flex items-center gap-1 rounded-full border border-amber-500 bg-amber-950/80 px-1.5 py-0.5 text-[9px] font-bold uppercase text-amber-300">
          <TriangleAlert className="h-3 w-3" /> Flagged
        </span>
      )}
      <span className="absolute right-2 top-2 h-2.5 w-2.5 rounded-full" style={{ background: cfg.dot, boxShadow: `0 0 10px ${cfg.dot}` }} />
      {site.last_thumb_id && (
        <img src={fileUrl(site.last_thumb_id)} alt="" className="absolute inset-0 h-full w-full object-cover opacity-20" />
      )}
      <div className="relative">
        <p className="font-head text-base font-bold leading-tight text-foreground">{POSITIONS[site.position_type]}</p>
        {site.campaign_name && (
          <p className="mt-0.5 truncate text-[11px] text-muted-foreground">{site.campaign_name}</p>
        )}
      </div>
      <span className={`relative inline-flex w-fit items-center rounded-md border px-1.5 py-0.5 text-[10px] font-mono uppercase tracking-wide ${cfg.badge}`}>
        {cfg.label}
      </span>
    </button>
  );
}
